<template>
  <div
    :class="componentClass"
    :style="componentStyle"
  >
    <wa-sample-spinner :size="`${iconSize}`" />
    <p class="margin-top-xl margin-bottom-0">{{ content }}</p>
  </div>
</template>

<script>
  export default {
    name: 'ElementLoading',

    props: {
      content: {
        type: String,
        default: 'Loading this is. Patience you must have.'
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      iconSize: {
        type: String,
        default: '3x'
      },
      isMuted: {
        type: Boolean,
        default: true
      },
      lineLength: {
        type: String,
        default: 'sm'
      },
      paddingY: {
        type: String,
        default: '4xl'
      }
    },

    computed: {
      componentClass() {
        return [`margin-auto text-center padding-y-${this.paddingY} line-length-${this.lineLength}`, { muted: this.isMuted }]
      },
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    }
  }
</script>
